import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { cssVar } from '@chakra-ui/theme-tools';
var _tooltip;
var bg = cssVar('tooltip-bg');
var arrowBg = cssVar('popper-arrow-bg');
var baseStyle = {
  tooltip: (_tooltip = {}, _defineProperty(_tooltip, bg.variable, "colors.white"), _defineProperty(_tooltip, "bg", [bg.reference]), _defineProperty(_tooltip, arrowBg.variable, [bg.reference]), _defineProperty(_tooltip, "p", 2), _defineProperty(_tooltip, "borderRadius", 'base'), _defineProperty(_tooltip, "fontSize", 'xs'), _defineProperty(_tooltip, "boxShadow", 'lg'), _defineProperty(_tooltip, "maxW", '320px'), _defineProperty(_tooltip, "zIndex", 'tooltip'), _tooltip)
};
function variantInverted() {
  var _tooltip2;
  return {
    tooltip: (_tooltip2 = {}, _defineProperty(_tooltip2, bg.variable, "colors.gray.800"), _defineProperty(_tooltip2, "bg", [bg.reference]), _defineProperty(_tooltip2, arrowBg.variable, [bg.reference]), _defineProperty(_tooltip2, "color", 'white'), _tooltip2)
  };
}
var variants = {
  inverted: variantInverted
};
var Tooltip = {
  variants: variants,
  baseStyle: baseStyle
};
export { Tooltip as default };